import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import FactDetailPage from './pages/FactDetailPage';
import CategoriesPage from './pages/CategoriesPage';
import CategoryDetailPage from './pages/CategoryDetailPage';

// 臨時頁面組件
const SubmitPage = () => <div>投稿頁面</div>;
const AuthPage = () => <div>登入頁面</div>;
const NotFoundPage = () => <div>404 頁面未找到</div>;

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="categories/:slug" element={<CategoryDetailPage />} />
        <Route path="submit" element={<SubmitPage />} />
        <Route path="auth" element={<AuthPage />} />
        <Route path="facts/:id" element={<FactDetailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
